
module.exports = ['$location', ($location) => {
    const service = {
      sync,
      getParams
    };
  
    function sync(ctrl, variableNames, multipleScope = false){
      const $scope = ctrl.$scope;
  
      const fromUrlToScope = () => {
        const searchUrl = this.getParams($scope.$id);
        console.debug('from url to scope ', $scope.$id, variableNames, searchUrl, Object.keys(searchUrl));
        
        variableNames.forEach((name) => {
          if(searchUrl[name]) $scope.ctrl[name] = searchUrl[name];
        });
  
        $scope.$emit('syncUrlChanged', searchUrl);
      };
  
      $scope.$on('$locationChangeSuccess', fromUrlToScope);
      fromUrlToScope();
  
      variableNames.forEach(name => {
        console.debug(`Start watching ctrl.${name}.`, $scope.$id);
        
        const fromScopeToUrl = newVal => {
          console.debug(`From scope to url ${name}=${newVal}`, $scope.$id);
          const searchUrl = $location.search();
  
          if(multipleScope){
            searchUrl[`${$scope.$id}_${name}`] = newVal;
          }else{
            searchUrl[name] = newVal;
          }
          
          $location.replace();
          $location.search(searchUrl);
        };
        
        $scope.$watch(`ctrl.${name}`, fromScopeToUrl, true);
        fromScopeToUrl(ctrl[name]);
      });
    }
  
    function getParams(id){
      const params = $location.search();
      const idRegEx = id ? new RegExp(`${id}_`, 'gi') : new RegExp('[0-9]+_', 'gi');
      let formatParams = {};
  
      Object.keys(params).forEach((param) =>{      
        let name = param
        if(idRegEx.test(param)) name = param.replace(idRegEx, '');
  
        formatParams[name] = params[param];
      });
  
      return formatParams;
    }
  
    return service;
  }];
  